export const resolvers = {

};


// WEBPACK FOOTER //
// ./src/graphql/resolvers.tsx